<div class="programers_content">
    <div class="sub_content">
        <h1 class="title">
            F A B<br>
        </h1>
        <div class="img_txt_list boysImg_deskView">

            <div class="program_img_list_content">
                <div class="row">
                    <div class="col-md-4">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/feature.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Feature</div>
                                
                                <div class="para_content">
                                    
                                    <li>Join Our Leading Franchise Network Offering Playgroup to Grade 5 Services.</li>
                                    <li>Join Our Leading Franchise Network Offering Playgroup to Grade 5 Services.
                                        Franchise Opportunities with Expert Academic & Marketing Support from ZLL</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/advantage.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Advantage</div>
                                
                                <div class="para_content">
                                    
                                    <li>Expand Your Kidzee Preschool with Board-Aligned Curriculum & Ready Customers</li>
                                    <li>Freadom English Program & Board Ready Curriculum for India’s Future Leaders</li>
                                    <li>Join Zee Learn: NEP- Compliant Curriculum with Continuity to Primary Education</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/benefit.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Benefit</div>
                                
                                <div class="para_content">
                                    
                                    <li>Ensure Seamless School Continuity for Sustained Growth and Stability.</li>
                                    <li>Unlock Assured Long-Term Revenue with Our Proven Education Model.</li>
                                    <li>Achieve Big Plans in Manageable Steps with Our Franchise Opportunity</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="mobile_res">
            <div class="container my-4">
                <div class="contain">
                    <div id="carousel2" class="owl-carousel owl-theme">
                      <div class="item">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/feature.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Feature</div>
                                
                                <div class="para_content">
                                    
                                    <li>Join Our Leading Franchise Network Offering Playgroup to Grade 5 Services.</li>
                                    <li>Join Our Leading Franchise Network Offering Playgroup to Grade 5 Services.
                                        Franchise Opportunities with Expert Academic & Marketing Support from ZLL</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                      </div>
                      <div class="item">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/advantage.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Advantage</div>
                                
                                <div class="para_content">
                                    
                                    <li>Expand Your Kidzee Preschool with Board-Aligned Curriculum & Ready Customers</li>
                                    <li>Freadom English Program & Board Ready Curriculum for India’s Future Leaders</li>
                                    <li>Join Zee Learn: NEP- Compliant Curriculum with Continuity to Primary Education</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                      <div class="item">
                        <div class="card_content">
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/benefit.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Benefit</div>
                                
                                <div class="para_content">
                                    
                                    <li>Ensure Seamless School Continuity for Sustained Growth and Stability.</li>
                                    <li>Unlock Assured Long-Term Revenue with Our Proven Education Model.</li>
                                    <li>Achieve Big Plans in Manageable Steps with Our Franchise Opportunity</li>
                                    
                                </div>
                                
                            </div>
                        </div>
                      </div>
                     
                    </div>
            </div>
        </div>

    </div>
</div>